var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.615387H24V16.413H0V0.615387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.615204H10.5V7.0329H0V9.99493H10.5V16.4126H13.5V9.99493H24V7.0329H13.5V0.615204Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4584 11.2613L23.9997 14.3009V11.2613H18.4584ZM14.6084 11.2613L23.9997 16.4127V14.956L17.2641 11.2613H14.6084ZM21.4982 16.4127L14.6084 12.6331V16.4127H21.4982Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6084 11.2613L23.9997 16.4127V14.956L17.2641 11.2613H14.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6084 11.2613L23.9997 16.4127V14.956L17.2641 11.2613H14.6084Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23473 11.2612L0 13.5841V11.2612H4.23473ZM9.39131 11.9163V16.4126H1.19489L9.39131 11.9163Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73561 11.2613L0 14.956V16.4127L9.39131 11.2613H6.73561Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54133 5.76654L0 2.72694V5.76654H5.54133ZM9.39131 5.76654L0 0.615204V2.07187L6.73561 5.76654H9.39131ZM2.50153 0.615204L9.39131 4.39475V0.615204H2.50153Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39131 5.76654L0 0.615204V2.07187L6.73561 5.76654H9.39131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39131 5.76654L0 0.615204V2.07187L6.73561 5.76654H9.39131Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.765 5.76668L23.9997 3.4438V5.76668H19.765ZM14.6084 5.11161V0.615295H22.8048L14.6084 5.11161Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2641 5.76657L23.9997 2.0719V0.615234L14.6084 5.76657H17.2641Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.7975,
    fill: "white",
    transform: "translate(0 0.615387)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.7bf02a1871b064e5e48e29a2455eb72b.svg";
export { ForwardRef as ReactComponent };